module.exports = __webpack_public_path__ + "img/logo_black.1e37d833.svg";